import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    Grid,
    InputLabel,
    List,
    ListItem,
    makeStyles,
    MenuItem,
    Select,
    Switch,
    TextField,
    Typography,
    useMediaQuery,
    useTheme,
} from "@material-ui/core"
import { useContext, useState } from "react"
import logo99 from "../../../assets/99-app-logo-0.png"
import { alertStart } from "../../../routes"
import { SalvarCardapio99Food } from "../../../services/99food"
import useAppStore from "../../../stores/AppStore"
import useLoadingStore from "../../../stores/LoadingStore"
import { Sincronizacao99Context } from "../Cardapionovo"
import Categorias from "./Categorias"
import DialogCategorias from "./DialogCategorias"
import DialogDuplicarGrupoDeOpcao from "./DialogDuplicarGrupoDeOpcao"
import DialogPassoDeMontagem from "./DialogPassoDeMontagem"
import DialogProdutos from "./DialogProdutos"

const useStyles = makeStyles(() => ({
    container: {
        textAlign: "left",
        display: "flex",
        flexDirection: "column",
    },
    cabecalho: {
        position: "fixed",
        top: "64px",
        left: "80px",
        display: "flex",
        flexWrap: "wrap",
        gap: "0.5rem",
        "& .container-opcoes-categorias": {
            display: "flex",
            flex: "1 0 36rem",
            gap: "0.5rem",
            flexWrap: "wrap",
            "&>*": {
                flex: 1,
            },
        },
        zIndex: 9,
        width: "calc(100vw - 80px)",
        backgroundColor: "white",
        padding: "0.8rem",
        borderBottom: "solid 1px rgba(0,0,0, 0.4)",
        paddingRight: "1.2rem",
    },
    botaoCadastrar: {
        backgroundColor: "red",
        color: "white",
        "&:hover": {
            backgroundColor: "#FF4D4D",
        },
    },
    botaoSalvar: {
        backgroundColor: "#14A44D",
        color: "white",
        "&:hover": {
            backgroundColor: "#28B76C",
        },
    },
    botaoSalvar99: {
        backgroundColor: "#FFD429",
        color: "white",
        "&:hover": {
            // TODO: Alterar cor levemente?
            backgroundColor: "#FFD429",
        },
    },
    containerItens: {
        flexGrow: 1,
        marginTop: "3.2rem",
    },
    listItem: {
        paddingLeft: "0",
        paddingRight: "0",
    },
}))

export default function NovaTelaProdutos({
    cardapio,
    estabelecimento,
    handleSalvarProduto,
    handleSalvarCategoria,
    cadastrar,
    setCadastrar,
    categorias,
    setCategorias,
    handleDuplicarCategoria,
    handleDuplicarProduto,
    handleDuplicarPassoDeMontagem,
    handleExcluirCategoria,
    handleExcluirProduto,
    handleCadastrarGrupoDeOpcao,
    handleExcluirGrupoDeOpcao,
    handleCadastrarOpcao,
    handleExcluirOpcao,
    handleSalvarCardapioInteiro,
    handleIdsEditar,
    handleCadastrarImagem,
    setSalvarCardapioCompleto,

    insumos,
    insumoSelecionado,
    insumosSelecionados,
    fichaTecnica,
    quantidades,
    handleAddInsumo,
    handleDeleteInsumo,
    salvarFt,
    setInsumoSelecionado,
    setQuantidades,
    setAltInsumo,
    buscarFT,
    produto,
}) {
    const theme = useTheme()
    const mobile = useMediaQuery(theme.breakpoints.down("sm"))
    const classes = useStyles()

    const setLoading = useLoadingStore(s => s.setLoading)

    const atualizarConfiguracoes = useAppStore(s => s.atualizarConfiguracoes)
    const configuracoes = useAppStore(s => s.configuracoes)

    const { openSincronizacao99, handleCloseSincronizacao99, sincronizar99Handler } =
        useContext(Sincronizacao99Context)

    const [categoriaAtual, setCategoriaAtual] = useState("")
    const [produtoAtual, setProdutoAtual] = useState("")

    const [valorPesquisa, setValorPesquisa] = useState("")

    const [openCategoria, setOpenCategoria] = useState(false)
    const handleClickOpenCategoria = () => {
        setOpenCategoria(true)
    }

    const [openProduto, setOpenproduto] = useState(false)
    const handleCloseProduto = () => {
        setAltInsumo(false)
        setOpenproduto(false)
    }
    const [openPassoDeMontagem, setOpenPassoDeMontagem] = useState(false)

    const [modalCategoria, setModalCategoria] = useState(null)
    const handleCloseCategoria = () => {
        setOpenCategoria(false)
    }

    const [idPasso, setIdPasso] = useState(null)
    const [openDuplicarGrupoDeMontagem, setOpenDuplicarGrupoDeMontagem] = useState(false)
    const handleToggleDuplicarGrupoDeMontagem = data => {
        setIdPasso(data)
        setOpenDuplicarGrupoDeMontagem(prev => !prev)
    }

    const [modalProduto, setModalProduto] = useState(null)
    const [modalPasso, setModalPasso] = useState(null)

    const handleChangeCategoria = e => {
        if (!e.target.value) {
            setCategorias(cardapio.categorias)
        } else {
            setCategorias(
                cardapio.categorias.filter(cat => cat.exibicaoCategoriaEnum === e.target.value)
            )
        }
    }

    const procurarProduto = e => {
        setValorPesquisa(e.target.value.toLowerCase())
        setCategorias(
            cardapio.categorias.filter(busca =>
                busca.nome.toLowerCase().includes(e.target.value.toLowerCase())
            )
        )
    }

    const [draggingItem, setDraggingItem] = useState(null)

    const handleDragOver = index => {
        if (draggingItem === null) return
        if (draggingItem === index) return
        const itens = categorias.filter((_, idx) => idx !== draggingItem)
        itens.splice(index, 0, categorias[draggingItem])
        itens.forEach((item, idx) => {
            item.ordemExib = idx
        })
        setCategorias(itens)
        setDraggingItem(index)
    }

    const [openConfirmacaoSalvar99, setOpenConfirmacaoSalvar99] = useState(false)
    const handleCloseConfirmacaoSalvar99 = () => setOpenConfirmacaoSalvar99(false)
    const salvarCardapio99 = async () => {
        setLoading(true)

        try {
            const response = await SalvarCardapio99Food(cardapio)

            alertStart("Enviado para atualização!", "success")
            handleCloseConfirmacaoSalvar99()
        } catch (error) {
            console.error("Erro Salvar99", error.response)

            alertStart(error.response.data, "error")
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <DialogCategorias
                open={openCategoria}
                cadastrar={cadastrar}
                modalCategoria={modalCategoria}
                estabelecimento={estabelecimento}
                handleCloseCategoria={handleCloseCategoria}
                handleSalvarCategoria={handleSalvarCategoria}
            />
            <DialogProdutos
                open={openProduto}
                modalProduto={modalProduto}
                cadastrar={cadastrar}
                handleCloseProduto={handleCloseProduto}
                handleSalvarProduto={handleSalvarProduto}
                categorias={categorias}
                categoriaAtual={categoriaAtual}
                handleCadastrarImagem={handleCadastrarImagem}
                estabelecimento={estabelecimento}
                insumos={insumos}
                insumoSelecionado={insumoSelecionado}
                insumosSelecionados={insumosSelecionados}
                fichaTecnica={fichaTecnica}
                quantidades={quantidades}
                handleAddInsumo={handleAddInsumo}
                handleDeleteInsumo={handleDeleteInsumo}
                salvarFt={salvarFt}
                setInsumoSelecionado={setInsumoSelecionado}
                setQuantidades={setQuantidades}
                setAltInsumo={setAltInsumo}
                buscarFT={buscarFT}
                produto={produto}
            />
            <DialogPassoDeMontagem
                open={openPassoDeMontagem}
                setOpenPassoDeMontagem={setOpenPassoDeMontagem}
                modalPasso={modalPasso}
                cadastrar={cadastrar}
                handleCadastrarGrupoDeOpcao={handleCadastrarGrupoDeOpcao}
                produtoAtual={produtoAtual}
            />
            <DialogDuplicarGrupoDeOpcao
                open={openDuplicarGrupoDeMontagem}
                handleToggleDuplicarGrupoDeMontagem={handleToggleDuplicarGrupoDeMontagem}
                categorias={categorias}
                handleDuplicarPassoDeMontagem={handleDuplicarPassoDeMontagem}
                idPasso={idPasso}
            />
            <div
                className={classes.container}
                style={{
                    width: mobile ? "" : "calc(100vw - 97px)",
                    padding: mobile ? "" : "0px 16px",
                }}
            >
                <div className={classes.cabecalho}>
                    <div className="container-opcoes-categorias">
                        <Button
                            className={classes.botaoCadastrar}
                            onClick={() => {
                                handleClickOpenCategoria()
                                setCadastrar(true)
                                setModalCategoria(null)
                            }}
                        >
                            Cadastrar Categoria
                        </Button>
                        <FormControl size="small" variant="outlined">
                            <InputLabel>Tipo Categoria</InputLabel>
                            <Select
                                label="Tipo Categoria"
                                defaultValue={null}
                                onChange={handleChangeCategoria}
                                style={{ backgroundColor: "#fff" }}
                            >
                                <MenuItem value={null}>Todos</MenuItem>
                                <MenuItem value="DELIVERY">Delivery</MenuItem>
                                <MenuItem value="PEDIDO_MESA">Mesa</MenuItem>
                                <MenuItem value="REGISTRADOR">Estabelecimento</MenuItem>
                            </Select>
                        </FormControl>
                        <TextField
                            type="text"
                            variant="outlined"
                            label="Procurar Categoria"
                            placeholder="Buscar"
                            size="small"
                            InputLabelProps={{ shrink: true }}
                            onChange={procurarProduto}
                            value={valorPesquisa}
                            style={{ backgroundColor: "#fff", minWidth: "12rem" }}
                        />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "0.5rem",
                            justifyContent: "flex-end",
                            flex: "1 0 36rem",
                        }}
                    >
                        <Button
                            onClick={() => {
                                handleSalvarCardapioInteiro()
                            }}
                            className={classes.botaoSalvar}
                        >
                            Salvar
                        </Button>
                        {!configuracoes.cardapio?.sincronizarCardapio99Automaticamente ? (
                            <Button
                                onClick={() => setOpenConfirmacaoSalvar99(true)}
                                className={classes.botaoSalvar99}
                                endIcon={<img src={logo99} alt="" height={20} width={20} />}
                            >
                                Sincronizar
                            </Button>
                        ) : null}
                        <FormControlLabel
                            style={{ margin: 0 }}
                            control={
                                <Switch
                                    checked={
                                        configuracoes.cardapio?.sincronizarCardapio99Automaticamente
                                    }
                                    onChange={() =>
                                        atualizarConfiguracoes({
                                            cardapio: {
                                                sincronizarCardapio99Automaticamente:
                                                    !configuracoes.cardapio
                                                        ?.sincronizarCardapio99Automaticamente,
                                            },
                                        })
                                    }
                                />
                            }
                            label={
                                <>
                                    Sincronizar{" "}
                                    <img src={logo99} alt="" height={24} width={24} style={{}} />{" "}
                                    automaticamente
                                </>
                            }
                        />
                    </div>
                </div>
                <Grid className={classes.containerItens}>
                    <List fullWidth>
                        {categorias?.map((categoria, index) => (
                            <ListItem
                                className={classes.listItem}
                                key={categoria.id}
                                onDragOver={() => handleDragOver(index)}
                            >
                                <Categorias
                                    index={index}
                                    estabelecimento={estabelecimento}
                                    setOpenCategoria={setOpenCategoria}
                                    categoria={categoria}
                                    cardapio={cardapio}
                                    setOpenproduto={setOpenproduto}
                                    setCadastrar={setCadastrar}
                                    setModalCategoria={setModalCategoria}
                                    setModalProduto={setModalProduto}
                                    setModalPasso={setModalPasso}
                                    setOpenPassoDeMontagem={setOpenPassoDeMontagem}
                                    setDraggingItem={setDraggingItem}
                                    setCategoriaAtual={setCategoriaAtual}
                                    setProdutoAtual={setProdutoAtual}
                                    handleSalvarProduto={handleSalvarProduto}
                                    handleDuplicarCategoria={handleDuplicarCategoria}
                                    handleDuplicarProduto={handleDuplicarProduto}
                                    handleDuplicarPassoDeMontagem={handleDuplicarPassoDeMontagem}
                                    handleExcluirCategoria={handleExcluirCategoria}
                                    handleExcluirProduto={handleExcluirProduto}
                                    handleCadastrarGrupoDeOpcao={handleCadastrarGrupoDeOpcao}
                                    handleExcluirGrupoDeOpcao={handleExcluirGrupoDeOpcao}
                                    handleCadastrarOpcao={handleCadastrarOpcao}
                                    handleExcluirOpcao={handleExcluirOpcao}
                                    handleIdsEditar={handleIdsEditar}
                                    handleToggleDuplicarGrupoDeMontagem={
                                        handleToggleDuplicarGrupoDeMontagem
                                    }
                                    handleCadastrarImagem={handleCadastrarImagem}
                                    setSalvarCardapioCompleto={setSalvarCardapioCompleto}
                                    insumos={insumos}
                                    insumoSelecionado={insumoSelecionado}
                                    insumosSelecionados={insumosSelecionados}
                                    fichaTecnica={fichaTecnica}
                                    quantidades={quantidades}
                                    handleAddInsumo={handleAddInsumo}
                                    handleDeleteInsumo={handleDeleteInsumo}
                                    salvarFt={salvarFt}
                                    setInsumoSelecionado={setInsumoSelecionado}
                                    setQuantidades={setQuantidades}
                                    setAltInsumo={setAltInsumo}
                                    buscarFT={buscarFT}
                                />
                            </ListItem>
                        ))}
                    </List>
                </Grid>
            </div>
            <Dialog open={openSincronizacao99} onClose={handleCloseSincronizacao99} maxWidth="xs">
                <DialogTitle>
                    Sincronização <img src={logo99} alt="Logo 99" height={36} width={36} />
                </DialogTitle>
                <DialogContent>
                    Deseja sincronizar esta alteração com a 99?
                    <FormControlLabel
                        style={{ margin: 0, marginTop: "1rem" }}
                        control={
                            <Checkbox
                                checked={
                                    configuracoes.cardapio?.sincronizarCardapio99Automaticamente
                                }
                                onChange={e =>
                                    atualizarConfiguracoes({
                                        cardapio: {
                                            sincronizarCardapio99Automaticamente: e.target.checked,
                                        },
                                    })
                                }
                            />
                        }
                        label={
                            <Typography variant="body2">
                                Sempre sincronizar automaticamente
                            </Typography>
                        }
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseSincronizacao99}>Fechar</Button>
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={() => {
                            setLoading(true)

                            sincronizar99Handler()

                            setTimeout(() => {
                                setLoading(false)
                                handleCloseSincronizacao99()
                            }, 1500)
                        }}
                    >
                        Sincronizar
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openConfirmacaoSalvar99}
                onClose={handleCloseConfirmacaoSalvar99}
                maxWidth="xs"
            >
                <DialogTitle>
                    Salvar Cardápio <img src={logo99} alt="Logo 99" height={36} width={36} />
                </DialogTitle>
                <DialogContent style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <Typography>Atenção!</Typography>
                    <Typography>
                        Você está prestes a atualizar o cardápio da 99Food. Esta operação irá
                        reescrever o cardápio atual e não poderá ser desfeita.
                    </Typography>
                    <Typography>Deseja continuar?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseConfirmacaoSalvar99}>Fechar</Button>
                    <Button color="primary" variant="contained" onClick={salvarCardapio99}>
                        Salvar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
